import { render, staticRenderFns } from "./onboardingGuide.vue?vue&type=template&id=150c4055&scoped=true"
import script from "./onboardingGuide.vue?vue&type=script&lang=js"
export * from "./onboardingGuide.vue?vue&type=script&lang=js"
import style0 from "./onboardingGuide.vue?vue&type=style&index=0&id=150c4055&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150c4055",
  null
  
)

export default component.exports